<template>
  <b-modal id="bundleModal" :title="title" size="lg" @show="onShow">
    <div class="flex items-center justify-between mb20">
      <div>
        <p>묶음배송할 처방을 선택해주세요.</p>
        <strong style="color: red" class="fwb text-xs"
          >* 탕전처방, 약속탕전, 약속처방 서로 다른 제형은 묶음신청이
          불가능합니다.</strong
        >
      </div>
    </div>
    <div class="search user_modal">
      <div
        class="table_list mb30"
        style="
          max-height: 480px;
          height: 480px;
          overflow: hidden;
          overflow-y: auto;
        "
      >
        <table class="list no_view text-sm">
          <colgroup>
            <col width="50" />
            <col width="150" />
            <col width="50" />
            <col width="100" />
            <col width="100" />
            <col width="100" />
            <col width="200" />
            <col width="100" />
            <col width="200" />
            <col width="100" />
          </colgroup>
          <thead>
            <tr>
              <th>선택</th>
              <th>주문번호</th>
              <th>분류</th>
              <th>환자명</th>
              <th>처방명</th>
              <th>보내는사람</th>
              <th>보내는주소</th>
              <th>받는사람</th>
              <th>받는주소</th>
              <th>배송비</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item  , index) in deliveryList" :key="index">
              <td>
                <div v-if="item.is_combined == 'Y'" class="flex jc">
                  <b-badge variant="success">
                    묶음
                  </b-badge>
                </div>
                <div class="form_checkbox" v-else style="min-width: auto">
                  <input
                    type="checkbox"
                    :id="'deliveryCheckbox' + index"
                    name="checkbox"
                    :value="item.prescribe_seq"
                    v-model="checkedSeqs"
                    @change="fn_check_change($event,item)"
                  />
                  <label :for="'deliveryCheckbox' + index" class="jc"></label>
                </div>
              </td>
              <td>
                <span>{{ item.prescribe_seq }}</span>
              </td>
              <td>
                <span v-if="item.prescribe_type == 'T'" class="font_orange">탕전</span>
                <span v-if="item.prescribe_type == 'I'" class="font_green">첩약</span>
                <span v-if="item.prescribe_type == 'P'" class="font_blue">약속</span>
              </td>
              <td>
                <span>{{ item.patient_nm }}</span>
              </td>
              <td class="al">
                <span>{{ item.prescribe_nm }}</span>
              </td>
              <td>
                <span>{{ item.send_nm }}</span>
              </td>
              <td>
                <span>{{ item.send_addr  }} {{ item.send_addr_dtl  }}</span>
              </td>
              <td>
                <span>{{ item.receive_nm }}</span>
              </td>
              <td>
                <span>{{ item.receive_addr  }} {{ item.receiveaddr_dtl  }}</span>
              </td>
              <td>
                <span>{{ fn_comma_won(item.total_delivery_price) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />
    <div class="flex items-center jc gap8">
      <p class="text-sm fwb">묶음배송주소</p>
      <div class="form_select">
        <b-form-select v-model="combineMainOrder">
          <b-form-select-option value="">
            메인 주문을 선택해주세요.
          </b-form-select-option>
          <b-form-select-option v-for="(item, index) in checkList" :key="index" :value="item.prescribe_seq">{{item.prescribe_seq}}</b-form-select-option>
        </b-form-select>
      </div>
      <button class="btn btn_md btn_deepbrown" @click="fn_combine_delivery">
        묶음신청하기
      </button>
    </div>
    <template #modal-footer>
      <div></div>
    </template>

    <alert-modal 
      :id="'alert'"
      :text="showAlertMsg" 
      :btnRight="'확인'" 
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="false"
      v-on:update:showSetting="fn_showSet"
    />
  </b-modal>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  name: "writeModal",
  props: {
    title: String,
    deliveryList : []
  },
  components: {
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      // 체크된 prescribe_seq 목록
      checkedSeqs: [],
      // 선택된 항목만 필터링해서 담는 리스트
      checkList: [],

      combineMainOrder : ''
    };
  },
  mounted() {

  },
  methods: {
    onShow() {
      //모달창이 열릴때마다
      //상품 배송 정보를 가져온다.
      // let itemList= this.list.map(item => item.seq)

      // let param = new Object();
      // param.prescribesSeqList = itemList;

      // axios
      //   .post("/api/user/mypage/getDeliveryInfoList", param)
      //   .then((res) => {
      //       console.log("@@@@ res : %o",res);
      //       this.deliveryInfoList = res.data.deliveryInfoList;
                   

      //   })
      //   .catch((err) => console.log(err));
      
    },
    // handleClick: function () {
    //   this.data.forEach((item) => {
    //     item.key1 = "묶음처방";
    //   });
    // },
    fn_check_change(e, item){

       const seq = item.prescribe_seq;

      // 1) 현재 체크 상태 확인 (change 이후 상태이므로 includes로 판단)
      const isCheckedNow = this.checkedSeqs.includes(seq);

      // 2) 체크가 "된 경우"에만 조건 검증 (해제는 그냥 통과)
      if (isCheckedNow) {
        const ok = this.validatePrescribeType(item.prescribe_type);

        if (!ok) {
          // 조건 불만족 -> 배열에서 제거하여 체크 해제
          this.checkedSeqs = this.checkedSeqs.filter(v => v !== seq);

          // 2) DOM 체크도 강제로 해제(즉시 반영 보강)
          this.$nextTick(() => {
            e.target.checked = false;
          });

          // 필요 시 메시지
          let msg = "약속상품만 가능합니다";
          this.fn_open_alert(msg);
          
        }

        const selectedSet = new Set(this.checkedSeqs);
        this.checkList = this.deliveryList.filter(item => selectedSet.has(item.prescribe_seq));
      }

    },
    validatePrescribeType(prescribeType) {
      // 여기에 조건 로직 구현
      // 예) 특정 타입만 허용
      const allowed = ['P'];
      return allowed.includes(prescribeType);
    },
    fn_combine_delivery(){

      if(this.combineMainOrder == null || this.combineMainOrder == ""){
        let msg = "메인 주문을 선택해주세요";
        this.fn_open_alert(msg);
        return;
      }

      let param = new Object();
      param.mainPrescribe = this.combineMainOrder;
      param.combineList = this.checkList;

      axios
        .post("/api/user/mypage/processCombined", param)
        .then((res) => {
            
            // 묶음 처리 정보 부모창 갱신
            this.$emit('update-combine', res.data.combineProcessList)

        })
        .catch((err) => console.log(err));

    }
  },
};
</script>

<style scoped>
.custom-select {
  width: 500px;
}
</style>
